var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeli(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 82.3 82.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #304a6e;\r\n        stroke: #fff;\r\n        stroke-miterlimit: 10;\r\n        stroke-width: 4px;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #fff;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 41.15,
    cy: 41.15,
    r: 39.15
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 40.67,
    cy: 32.01,
    rx: 7.09,
    ry: 15.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 39.12,
    y: 39.04,
    width: 2.84,
    height: 23.91
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 39.79,
    y: 6.61,
    width: 2.7,
    height: 51.21,
    rx: 1.35,
    ry: 1.35,
    transform: "translate(34.83 -19.66) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 39.8,
    y: 6.6,
    width: 2.7,
    height: 51.21,
    rx: 1.35,
    ry: 1.35,
    transform: "translate(-10.72 38.53) rotate(-45)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "40.5 63.73 28.85 68.59 28.85 65.15 40.5 57.95 40.5 63.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "40.5 63.73 52.15 68.59 52.15 65.15 40.5 57.95 40.5 63.73"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeli);
export default __webpack_public_path__ + "static/media/heli.1981f7d55af928474e2a2ab0c1671fd9.svg";
export { ForwardRef as ReactComponent };